import { gsap } from "gsap";
import { EasePack as gsapEasePack } from "gsap/EasePack";

gsap.registerPlugin(gsapEasePack);

window.gsap = gsap;
window.gsapEasePack = gsapEasePack;

window._gsapEffects = {
    shakeElement: el => gsap.fromTo(el, 0.3, {x: -1}, {x: 1, ease: gsapEasePack.RoughEase.ease.config({strength: 8, points: 20, template: 'linear', randomize: false}) , clearProps: 'x'}),
};
